(function handlerDataLayer(global) {
  'use strict';

  if (!global.dataLayer) {
    return;
  }

  const dataLayerPush = global.dataLayer.push;
  const isFromEuropeanCountry = !!document.querySelector('[data-is-europan-country]');
  const eventsType = ['BingEvent', 'DotEvent'];
  const culture = document.documentElement.lang || 'en';
  const isCna = culture === 'es';

  /**
   * @private
   * isDirectLead: check if product is Direct Lead.
   *
   * @param {object} product send in ecomerce dataLayer.
   * @returns true if have a property name equal to Direct Leads, otherwise false.
   */
  function isDirectLead(product) {
    return product.name === 'Direct Leads';
  }

  /**
   * @private
   * getProductsTransactionComplete:
   *
   * @param {object} data send to dataLayer.
   * @returns Array of products if exist otherwise return an empty array.
   */
  function getProductsTransactionComplete(data) {
    const products = data && data.ecommerce && data.ecommerce.purchase && data.ecommerce.purchase.products;
    if (Array.isArray(products) && data.event === 'transactionComplete') {
      return products;
    }
    return [];
  }

  /**
   * @private
   * isDirectLeadTrasactionComplete: verify if the data send to dataLayer contains the:
   * event Name: transactionComplete
   * product Name: Direct Leads.
   * Don't execute in European countries.
   *
   * @param {object} data send to dataLayer.
   * @returns true if the event Name is transactionComplete and have an item in product array
   * that cotains the name Direct Leads, otherwise false.
   */
  function isDirectLeadTrasactionComplete(data) {
    const products = getProductsTransactionComplete(data);
    if (products.some(isDirectLead)) {
      return true;
    }
    return false;
  }

  /**
   * @private
   * isDirectRecommendedLead: check if is Direct Recommended Lead.
   *
   * @param {object} product send in ecomerce dataLayer.
   * @returns true if have a property name equal to Recommended Community Leads, otherwise false.
   */
  function isDirectRecommendedLead(product) {
    return product.name === 'Recommended Community Leads';
  }

  /**
   * @private
   * isDirectLeadTrasactionComplete: verify if the data send to dataLayer contains the:
   * event Name: transactionComplete
   * product Name: Direct Leads.
   * Don't execute in European countries.
   *
   * @param {object} data send to dataLayer.
   * @returns true if the event Name is transactionComplete and have an item in product array
   * that cotains the name Direct Leads, otherwise false.
   */
  function isDirectRecommendedLeadTrasactionComplete(data) {
    const products = getProductsTransactionComplete(data);
    if (products.some(isDirectRecommendedLead)) {
      return true;
    }
    return false;
  }

  /**
   * @private
   * triggerOnDemandTracker: dispatch the event trackOnDemandEvent
   *
   * @param {object} event object to be log in dataLayer.
   */
  function triggerOnDemandTracker(event) {
    if (document.body.dispatchEvent) {
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: {
          data: event
        }
      }));
    }
  }

  /**
   * @public
   * overridePush: override global dataLayer.push.
   *
   * @param {object} data send to dataLayer.
   */
  function overridePush(data) {
    // GoogleAnalyticsObject is not defined for some ad blockers
    if (dataLayerPush && typeof GoogleAnalyticsObject !== 'undefined') {
      dataLayerPush(data);
      dataLayerPush({
        params: null
      });
      const event = {
        isFromEuropeanCountry,
        isDirectLead: isDirectLeadTrasactionComplete(data),
        isDirectRecommendedLead: isDirectRecommendedLeadTrasactionComplete(data)
      };

      if (isCna) {
        return;
      }

      if (event.isDirectLead || event.isDirectRecommendedLead) {
        eventsType.forEach((eventType) => {
          event.eventType = eventType;
          triggerOnDemandTracker(event);
        });
      }
    }
  }

  global.dataLayer.push = overridePush;
}(window));
